//ActionTypes
///mastercronschedule/list/overdue
export const MASTERCRONSCHEDULE_LIST_OVERDUE =
  "mastercronschedule/list/overdue";
export const MASTERCRONSCHEDULE_LIST_OVERDUE_SUCCESS =
  "mastercronschedule/list/overdue/success";
export const MASTERCRONSCHEDULE_LIST_OVERDUE_FAILURE =
  "mastercronschedule/list/overdue/failure";
///mastercronschedule/list
export const MASTERCRONSCHEDULE_LIST = "mastercronschedule/list";
export const MASTERCRONSCHEDULE_LIST_SUCCESS =
  "mastercronschedule/list/success";
export const MASTERCRONSCHEDULE_LIST_FAILURE =
  "mastercronschedule/list/failure";
///mastercronschedule/requestrerun/166
export const MASTERCRONSCHEDULE_REQUESTRUN = "mastercronschedule/requestrerun";
export const MASTERCRONSCHEDULE_REQUESTRUN_SUCCESS =
  "mastercronschedule/requestrerun/success";
export const MASTERCRONSCHEDULE_REQUESTRUN_FAILURE =
  "mastercronschedule/requestrerun/failure";
